import axios from 'axios';
import TokenService from './token_service';
import { readSession, saveSession } from './auth_session';
// import store from '../../store';
// import store from '../../../store';

const axiosInstance = axios.create({
  baseURL: (process.env.VUE_APP_API_URL ?? 'http://localhost:3000') + '/v1',
  timeout: 120000
});

const applyRefreshPayload = (payload) => {
  saveSession({ token: payload?.token ?? payload, member: payload?.member || readSession().member });
};

let pendingRefresh = null;
let pendingRefreshToken = null;

const refreshSession = () => {
  const refreshToken = TokenService.getRefreshToken();
  if (pendingRefresh && pendingRefreshToken === refreshToken) return pendingRefresh;
  pendingRefreshToken = refreshToken;
  const request = axiosInstance.post('/public/auth/refreshToken', { refreshToken })
    .then(response => {
      if (TokenService.getRefreshToken() !== refreshToken) {
        throw new Error('Session changed while refreshing');
      }
      applyRefreshPayload(response.data);
    })
    .catch(error => {
      // A late response from the previous system must not erase a new login.
      if (TokenService.getRefreshToken() === refreshToken && error.response &&
          [401, 403].includes(error.response.status)) TokenService.clear();
      throw error;
    })
    .finally(() => {
      if (pendingRefresh === request) {
        pendingRefresh = null;
        pendingRefreshToken = null;
      }
    });
  pendingRefresh = request;
  return request;
};

axiosInstance.interceptors.request.use(function (config) {
  // Do something before request is sent
  const token = TokenService.getAccessToken();
  if (token) {
    // config.headers['Authorization'] = 'Bearer ' + token;
    config.headers.Authorization = 'Bearer ' + token;
  }
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

// Add a response interceptor
axiosInstance.interceptors.response.use(function (response) {
  // Do something with response data
  return response;
}, async function (error) {
  // Do something with response error
  // return Promise.reject(error);

  const originalConfig = error.config;
  if (originalConfig && !originalConfig.url.includes('/auth/') && error.response) {
    // Access Token was expired
    if (error.response.status === 401 && !originalConfig._retry && TokenService.isLogin()) {
      originalConfig._retry = true;
      try {
        await refreshSession();
        return axiosInstance(originalConfig);
      } catch (_error) {
        return Promise.reject(_error);
      }
    }
  }
  return Promise.reject(error);
});

class HttpRequest {
  constructor () {
    this.axios = axios;
  }

  async request (type, url, data) {
    // check jwt is expired before call // donut request
    if (TokenService.isExpired() && url.indexOf('/auth/') === -1 && url.indexOf('/public/') === -1) {
      await refreshSession();
    }

    let promise = null;

    switch (type) {
      case 'GET':
      case 'get':
        promise = axiosInstance.get(url, { params: data }); break;
      case 'POST':
      case 'post':
        axiosInstance.defaults.headers.post['Content-Type'] = 'application/json';
        promise = axiosInstance.post(url, JSON.stringify(data)); break;
      case 'UPLOAD':
      case 'upload':
        axiosInstance.defaults.headers.post['Content-Type'] = 'multipart/form-data;';
        const bodyFormData = new FormData();
        bodyFormData.append('file', data);
        promise = axiosInstance.post(url, bodyFormData); break;
      default :
        promise = axiosInstance.get(url, data); break;
    }
    return promise;
  }
}

export default HttpRequest;
